/**
 * User: daletan
 * Date: 6/24/14
 * Time: 1:01 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';
var $ = require('dibs-jquery-shim');
var d = window.document;
var scriptLoader;
var imgPixel;
var _pageEls;

/**
 * @returns {Object} pageEls, contains document head and body(if loaded) tag
 * @returns {HTMLElement} pageEls.head
 * @returns {HTMLElement} pageEls.body
 */
var getPageEls = function () {
    if (_pageEls) {
        // qucker if both are defined
        return _pageEls;
    }
    var $head = $('head');
    var $body = $('body');
    if ($head.length && $body.length) {
        //set private var for quicker lookup if both are defined
        _pageEls = {
            head : $head[0],
            body : $body[0]
        };
    } else if ($head.length) {
        // else return head if body isn't loaded
        return {
            head : $head[0]
        };
    }
    return _pageEls;
};

scriptLoader = {
    className : 'appended-script',


    /**
     *
     * @param {Object|Array} data If Object, needs these properties:
     * @param {string} data.base full base url up to the query parameters
     * @param {object} data.props Object of key/value pair properties to convert into query params
     *                            If Array, needs to just be the full URLs of the script tag, query params included b/c
     *                            this process will just `append` the script tags and not do any string manipulation
     * @param {boolean} async
     * @param {string} appendTo The element to append to from the `pageEls` object list
     * @param callBack {function} callBack function script load, passes src of loaded script
     * @returns {boolean}
     */
    load: function (data, async, appendTo, callBack) {

        var pageEls = getPageEls();

        if (async) {
            this.async = true;
        }
        this.remove();
        // which element to append the script tags to?
        this.el = pageEls[appendTo] ? pageEls[appendTo] : pageEls.head;
        if ($.isArray(data)) {
            for (var i = 0, len = data.length; i < len; i++) {
                this.append(data[i], callBack);
            }
            return false;
        } else if (!data.base) {
            console.log('a `base` property is need');
            return false;
        }
        var url = this.createUrl(data);
        if (url) {
            this.append(url, callBack);
        }
        return true;
    },
    remove: function () {
        var $els = $('.' + this.className);
        $els.remove();
    },
    /**
     * Creates a url string and adds any query parameters
     * @param data {Object} "base" (string) and "props" (object) need to be proeprties on this object
     */
    createUrl: function (data) {
        var url = data.base;
        var propsData = data.props;
        var props = [];
        for (var p in propsData) {
            if (propsData.hasOwnProperty(p)) {
                props.push(p + '=' + propsData[p]);
            }
        }
        if (props.length) {
            props = props.join('&');
            url += '?' + props;
        }
        return url;
    },
    /**
     * create a <script> block in the <head> with the
     * @param src {string} The source url to the script file to load
     * @param callBack {function} callBack function script load, passes src of loaded script
     */
    append: function (src, callBack) {
        if (src) {
            var script = d.createElement('script');
            script.type = 'text/javascript';
            script.src = src;
            script.className =  this.className;
            if (this.async) {
                script.defer = true;
                script.async = true;
                this.addScriptLoadCallBack(script, callBack, src);
            }
            this.el.appendChild(script);
        }
    },

    /**
     * @param {string} src the url of the script to load
     * @param {HTMLElement} script tag that's loading
     * @param {function} callBack fires when script loads, passing the the script src and readyState as a params
     */
    addScriptLoadCallBack: function (script, callBack, src) {
        if (typeof callBack !== 'function') {
            return;
        }
        script.onload = function () {
            callBack(src, script.readyState);
        };
    }
};

imgPixel = {
    className: 'appended-img-pixel',
    /**
     * Wrapper to create and load methods
     * @param {Array|String} data An array of src strings or a single src string
     * @returns {boolean}
     */
    load: function (data) {
        if (!data) {
            return [];
        }
        this.remove();
        if ($.isArray(data)) {
            for (var i = 0; i < data.length; i++) {
                this.createAndAppend(data[i]);
            }
        } else {
            this.createAndAppend(data);
        }
        return true;
    },
    remove: function () {
        var $els = $('.' + this.className);
        $els.remove();
    },
    createAndAppend: function (src) {
        var img = this.createImg(src);
        this.append(img);
    },
    createImg: function (src) {
        var img = d.createElement('img');
        img.src = src;
        img.width = 1;
        img.height = 1;
        img.className = this.className;
        return img;
    },
    append: function (img) {
        var pageEls = getPageEls();
        if (img) {
            pageEls.body.appendChild(img);
        }
    }
};

module.exports = {
    getPageEls: getPageEls,
    script: scriptLoader,
    pixel: imgPixel
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/scriptLoader.js
// module id = 2621
// module chunks = 62